const forms = document.querySelectorAll('.needs-validation')
Array.from(forms).forEach(form => {
    form.addEventListener('submit', function(event) {

        if (!form.checkValidity()) {
            event.preventDefault()
            event.stopPropagation()
        }

        form.classList.add('was-validated');

        var invalid = form.querySelector(':invalid');
        if (invalid) {

            if (!isElementInViewport(invalid.closest('.form-group'))) {
                var top = invalid.closest('.form-group').getBoundingClientRect().top + window.pageYOffset;
                document.documentElement.scrollTo({
                    top: top - 32,
                    behavior: "smooth"
                });
            }
        }

    }, false)
});

function validate_identical_password(pw2) {
    if (pw2.value !== pw2.closest('form').querySelector('[name="password"]').value) {
        pw2.setCustomValidity("Duplicate passwords do not match");
    } else {
        pw2.setCustomValidity(""); // is valid
    }
}

function isElementInViewport (el) {

    var rect = el.getBoundingClientRect();

    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && /* or $(window).height() */
        rect.right <= (window.innerWidth || document.documentElement.clientWidth) /* or $(window).width() */
    );
}